<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import { useClassStore } from '../../stores';
import Modal from '../General/Modal.vue';
import Button from '../General/Button.vue';
import Isaac from '../General/Isaac.vue';

const classStore = useClassStore()

const { t } = useI18n()
</script>

<template>
    <Modal v-model="classStore.isLockedScreen" :static="true" :close-btn="false" :transparent="true" size="medium">
        <template #backdrop>
            <div class="fixed inset-0 bg-black/90"></div>
        </template>
        <div class="flex flex-col items-center gap-20">
            <Isaac :text="t(TEXT.lock_screen_message)" />
            <Button type="outline" class="!bg-white !text-orange-600 select-none">
                {{ t(TEXT.teacher_locking_screen) }}
            </Button>
        </div>
    </Modal>
</template>